(function () {
  'use strict';
  const core = window.FsPriceCheckCore;
  document.querySelectorAll('[data-price-check]').forEach(panel => {
  const form = panel?.closest('form');
  if (!panel || !form || !core || panel.dataset.initialized) return;
  panel.dataset.initialized = 'true';
  const config = JSON.parse(panel.querySelector('[data-price-check-config]').textContent);
  const copy = Object.fromEntries(Object.entries(config.copy).map(([key,value])=>[key,core.copyText(value)])), endpoint = core.proxyPath(config.endpoint);
  const products = form.querySelector('[data-products]');
  const status = panel.querySelector('[data-price-check-status]');
  const intro = panel.querySelector('[data-price-check-intro]');
  const resultDetails = panel.querySelector('[data-price-check-details]');
  const resultList = panel.querySelector('[data-price-check-results]');
  const info = panel.querySelector('[data-price-check-info]');
  const all = panel.querySelector('[data-price-check-all]');
  const offerBox = panel.querySelector('[data-price-check-offer]');
  const apply = panel.querySelector('[data-price-check-apply]');
  const progress = panel.querySelector('[data-price-check-progress]');
  const bar = panel.querySelector('[data-price-check-bar]');
  const mode = panel.querySelector('[data-price-check-mode]');
  const spark = panel.querySelector('.fs-price-check__spark');
  const wavePath = spark.querySelector('[data-price-check-wave]');
  const waveNode = spark.querySelector('[data-price-check-wave-node]');
  const constellation = panel.querySelector('.fs-price-check__star-map svg');
  const completionPath = panel.querySelector('[data-price-check-morph]');
  const finishDuration = 1200;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let spinAnimation = null, finishTimer = null, finishRevealTimer = null;
  let constellationFrame = null, constellationBranches = [], constellationLinks = [], constellationStarted = 0, constellationFinished = null;
  let completionStarted = null, completionAngle = 0;
  let spinOffset = 0, spinAccelerationStarted = null;
  let idleWaveFrame = null, idleWaveTime = 0, openingStarted = null, openingPoints = null;
  const openingDuration = 820;
  const checkingRadius = 6.4;
  const restrictedVendors = String(config.restrictedVendors || '').split('\n').filter(s => s.trim());
  let generation = 0, busy = false, currentOffer = null, verifiedCart = null, expiryTimer;
  let pendingRefresh = null, writingDiscount = false, hasReviewed = endpoint ? false : config.hasReviewedItems === true, memoryReceipt = null, receiptVariantIds = null;
  const receiptKey = 'fs-price-review:' + config.themeId;
  const receiptScope = JSON.stringify({country:config.country,endpoint,restrictedVendors,offer:config.privateOffer,enabled:config.privateOfferEnabled});
  let restoredMarkup = null;
  function loadReceipt() {
    let receipt=memoryReceipt;
    try { const raw=localStorage.getItem(receiptKey); if(raw && raw.length<100000) receipt=JSON.parse(raw); } catch (_) {}
    return receiptVariantIds === null ? receipt : window.FsCartReview?.pruneReceipt(receipt,receiptVariantIds) || null;
  }
  function forgetReceipt() {
    memoryReceipt=null;
    receiptVariantIds=[];
    try { localStorage.removeItem(receiptKey); } catch (_) {}
  }
  function saveReceipt(cart,facts) {
    memoryReceipt=core.reviewReceipt(cart,facts,receiptScope);
    receiptVariantIds=null;
    try { localStorage.setItem(receiptKey,JSON.stringify(memoryReceipt)); } catch (_) {}
  }
  const controllers = new Set();
  const results = new Map();
  const format = (s, vars) => Object.entries(vars).reduce((out, [k, v]) => out.replace('{' + k + '}', String(v)), s);
  const money = (n, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}).format(n / 100);
  function element(tag, text, className) {
    const el = document.createElement(tag);
    if (text) el.textContent = text;
    if (className) el.className = className;
    return el;
  }
  function announce(message, attention = false) {
    status.classList.toggle('fs-price-check__status--quiet', !attention);
    status.replaceChildren(document.createTextNode(message));
    status.hidden = !message;
    intro.hidden = !!message;
  }
  function wavePoints(time = 0) {
    const phase=time*Math.PI*2/5600;
    const bezier=(a,b,c,d,t)=>{const u=1-t;return u*u*u*a+3*u*u*t*b+3*u*t*t*c+t*t*t*d;};
    return Array.from({length:25},(_,index)=>{
      const first=index<=12, t=first?index/12:(index-12)/12;
      const xs=first?[2,5,8,11]:[11,14,19,22];
      const ys=first?[12,6,6,12]:[12,18,18,12];
      const x=bezier(...xs,t), shape=bezier(...ys,t)-12;
      // The crest travels through the branded stroke; the whole logo does not bob as a block.
      return [x,12+shape*Math.cos(phase)+4.5*Math.cos(index/24*Math.PI*2)*Math.sin(phase)];
    });
  }
  function drawWave(points, dotOpacity = 1) {
    wavePath?.setAttribute('d','M'+points.map(point=>point.map(value=>value.toFixed(3)).join(' ')).join('L'));
    if(waveNode) {
      waveNode.setAttribute('cx',points[12][0].toFixed(3));
      waveNode.setAttribute('cy',points[12][1].toFixed(3));
      waveNode.style.opacity=String(dotOpacity);
    }
  }
  function startIdleWave() {
    cancelAnimationFrame(idleWaveFrame); idleWaveFrame=null;
    if(reducedMotion.matches) { if(panel.dataset.motion==='rest' || !panel.dataset.motion) drawWave(wavePoints(0)); return; }
    if(document.hidden || !panel.isConnected || (panel.dataset.motion && panel.dataset.motion!=='rest')) return;
    let lastPaint=0;
    const paint=now=>{
      if(document.hidden || !panel.isConnected || reducedMotion.matches || (panel.dataset.motion && panel.dataset.motion!=='rest')) {idleWaveFrame=null;return;}
      if(now-lastPaint>=32) {lastPaint=now;idleWaveTime=now;drawWave(wavePoints(now));}
      idleWaveFrame=requestAnimationFrame(paint);
    };
    idleWaveFrame=requestAnimationFrame(paint);
  }
  function paintOpening(now) {
    if(openingStarted===null || !openingPoints) return;
    const t=Math.max(0,Math.min(1,(now-openingStarted)/openingDuration)), blend=t*t*(3-2*t);
    drawWave(openingPoints.map((point,index)=>{
      const angle=-Math.PI/2+index/24*Math.PI*1.85;
      const circle=[12+Math.cos(angle)*checkingRadius,12+Math.sin(angle)*checkingRadius];
      return point.map((value,axis)=>value+(circle[axis]-value)*blend);
    }),1-Math.min(1,blend*2));
    panel.style.setProperty('--pc-web-emergence',Math.max(0,Math.min(1,(t-.25)/.65)));
    if(t===1) {openingStarted=null;openingPoints=null;}
  }
  function stopMotion() {
    clearTimeout(finishTimer); clearTimeout(finishRevealTimer);
    spinAnimation?.cancel(); spinAnimation=null;
    cancelAnimationFrame(constellationFrame); constellationFrame=null;
    cancelAnimationFrame(idleWaveFrame); idleWaveFrame=null;
    openingStarted=null; openingPoints=null;
    drawWave(wavePoints(idleWaveTime));
    constellationBranches=[]; constellationLinks=[]; constellationFinished=null;
    completionStarted=null;
    spinOffset=0; spinAccelerationStarted=null;
    completionPath?.setAttribute('d','M7.3 12.2L10.4 15.3L16.7 8.7');
    panel.dataset.motion='rest';
  }
  function currentSparkAngle() {
    if (typeof getComputedStyle==='function') {
      const matrix=getComputedStyle(spark).transform.match(/^matrix\(([^)]+)\)$/);
      if (matrix) {
        const values=matrix[1].split(',').map(Number);
        if (values.length===6 && values.every(Number.isFinite)) return (Math.atan2(values[1],values[0])*180/Math.PI+360)%360;
      }
    }
    return spinAnimation ? (spinOffset+(Number(spinAnimation.currentTime)||0)/2400*360)%360 : 0;
  }
  function paintCompletion(progress) {
    const smooth=value=>{const t=Math.max(0,Math.min(1,value));return t*t*(3-2*t);};
    const morph=smooth((progress-.18)/.82), fill=smooth((progress-.25)/.75);
    const turn=completionAngle+smooth(progress/.5)*Math.PI/3;
    const points=Array.from({length:25},(_,index)=>{
      const angle=turn+index/24*Math.PI*1.85;
      const circle=[12+Math.cos(angle)*checkingRadius,12+Math.sin(angle)*checkingRadius];
      const check=index<=8 ? [7.3+3.1*index/8,12.2+3.1*index/8] : [10.4+6.3*(index-8)/16,15.3-6.6*(index-8)/16];
      return circle.map((value,axis)=>(value+(check[axis]-value)*morph).toFixed(3)).join(' ');
    });
    completionPath?.setAttribute('d','M'+points.join('L'));
    const blend=(start,end,amount)=>'rgb('+start.map((value,index)=>Math.round(value+(end[index]-value)*amount)).join(',')+')';
    panel.style.setProperty('--pc-mark-opacity',smooth(progress/.18));
    panel.style.setProperty('--pc-star-opacity',1-smooth(progress/.35));
    panel.style.setProperty('--pc-disc-opacity',fill);
    panel.style.setProperty('--pc-completion-color',blend([40,112,207],[24,120,79],smooth(progress)));
    panel.style.setProperty('--pc-check-color',blend([40,112,207],[255,255,255],fill));
    panel.style.setProperty('--pc-check-width',1.4+.9*morph);
    panel.style.setProperty('--pc-field-opacity',1-smooth((progress-.18)/.82));
    panel.style.setProperty('--pc-field-scale',1+.04*smooth(progress));
  }
  function varyConstellation() {
    // The star map stays hidden: the wave, spinner and checkmark morph carry the whole animation.
    constellationBranches=[];
    constellationLinks=[];
  }
  function connectionPoints(start,middle,end) {
    const bounded=point=>[Math.max(-32,Math.min(16,point[0])),Math.max(-32,Math.min(32,point[1]))];
    const mix=(from,to,amount)=>from.map((value,axis)=>value+(to[axis]-value)*amount);
    const tangent=end.map((value,axis)=>(value-start[axis])*.18);
    const controls=[mix(start,middle,.45),bounded(middle.map((value,axis)=>value-tangent[axis])),
      bounded(middle.map((value,axis)=>value+tangent[axis])),mix(middle,end,.6)];
    return Array.from({length:25},(_,index)=>{
      const first=index<=12, t=first?index/12:(index-12)/12, u=1-t;
      const points=first?[start,controls[0],controls[1],middle]:[middle,controls[2],controls[3],end];
      return [0,1].map(axis=>u*u*u*points[0][axis]+3*u*u*t*points[1][axis]+3*u*t*t*points[2][axis]+t*t*t*points[3][axis]);
    });
  }
  function animateConstellation() {
    // Small, independent paths morph in place; the constellation never rotates as a rigid image.
    // Soft pulses flow along growing curves; connections stay intact instead of blinking off.
    constellationStarted=performance.now()+openingDuration;
    let lastPaint=0;
    const smooth=value=>{const t=Math.max(0,Math.min(1,value));return t*t*(3-2*t);};
    const bounded=(x,y)=>[Math.max(-32,Math.min(16,x)),Math.max(-32,Math.min(32,y))];
    const pair=point=>point.map(value=>value.toFixed(2)).join(' ');
    const paint=now=>{
      if (!panel.isConnected || reducedMotion.matches || document.hidden) { constellationFrame=null; return; }
      if (spinAccelerationStarted!==null && spinAnimation) {
        const acceleration=Math.min(1,Math.max(0,(now-spinAccelerationStarted-420)/800));
        const rate=smooth(acceleration);
        if (typeof spinAnimation.updatePlaybackRate==='function') spinAnimation.updatePlaybackRate(rate);
        else spinAnimation.playbackRate=rate;
        if (acceleration===1) spinAccelerationStarted=null;
      }
      paintOpening(now);
      if (completionStarted!==null) paintCompletion(Math.min(1,(now-completionStarted)/finishDuration));
      if (now-lastPaint>=32) {
        lastPaint=now;
        // Gradually slow the drifting points during the checkmark handoff, without freezing them.
        const elapsed=now-constellationStarted;
        const tail=constellationFinished===null?0:Math.max(0,now-constellationFinished);
        const clock=elapsed-(tail>0 ? .65*(tail-450*(1-Math.exp(-tail/450))) : 0);
        constellationBranches.forEach(branch=>{
          const age=clock-branch.delay;
          if (age<0) { branch.frame=null; return; }
          const cycle=(age%branch.period)/branch.period, t=clock/1000, p=branch.phase;
          const [baseX,baseY]=branch.end;
          const turn=.24*Math.sin(p*1.31), reach=.8+.15*(1+Math.sin(p*1.9))/2;
          const end=bounded((baseX*Math.cos(turn)-baseY*Math.sin(turn))*reach+Math.sin(t*.83+p)*2.2,
            (baseX*Math.sin(turn)+baseY*Math.cos(turn))*reach+Math.cos(t*.67+p*1.4)*2.5);
          const endRadius=Math.max(1,Math.hypot(...end)), bend=4.5*Math.sin(p*1.21+t*.34);
          let middle=bounded(end[0]*.55-end[1]/endRadius*bend+Math.sin(t*1.13+p),
            end[1]*.55+end[0]/endRadius*bend+Math.cos(t*.91+p));
          const originRadius=checkingRadius*28/24;
          const middleRadius=Math.hypot(...middle);
          if(middleRadius<originRadius+4) middle=bounded(...middle.map(value=>value*(originRadius+4)/middleRadius));
          const angle=Math.atan2(middle[1],middle[0]);
          const start=[Math.cos(angle)*originRadius,Math.sin(angle)*originRadius];
          const route=connectionPoints(start,middle,end);
          const d='M'+route.map(pair).join('L');
          const growth=smooth(age/1250);
          const visibility=smooth(age/360)*(.8+.12*Math.sin(t*.72+p));
          branch.group.setAttribute('opacity',visibility.toFixed(3));
          branch.path.setAttribute('d',d);
          branch.path.style.strokeDashoffset=String(1-growth);
          branch.signal.setAttribute('d',d);
          branch.signal.style.strokeDashoffset=String(1-smooth(cycle)*1.16);
          branch.signal.style.opacity=String(visibility*.55*smooth(cycle/.12)*(1-smooth((cycle-.82)/.18)));
          const lengths=route.slice(1).map((point,index)=>Math.hypot(point[0]-route[index][0],point[1]-route[index][1]));
          const middleFraction=lengths.slice(0,12).reduce((sum,length)=>sum+length,0)/lengths.reduce((sum,length)=>sum+length,0);
          const nodeOpacity=[smooth((growth-middleFraction+.05)/.12),smooth((growth-.92)/.08)];
          branch.frame={end,visibility:visibility*nodeOpacity[1]};
          [middle,end].forEach((point,index)=>{
            branch.nodes[index].setAttribute('cx',point[0].toFixed(2));
            branch.nodes[index].setAttribute('cy',point[1].toFixed(2));
            branch.nodes[index].style.opacity=String(nodeOpacity[index]);
            branch.nodes[index].setAttribute('r',(.9+index*.3+.08*Math.sin(t*.9+p)).toFixed(2));
          });
        });
        constellationLinks.forEach(link=>{
          const from=constellationBranches[link.from].frame,to=constellationBranches[link.to].frame;
          const visibility=from && to ? Math.min(from.visibility,to.visibility) : 0;
          link.group.setAttribute('opacity',visibility.toFixed(3));
          if (!from || !to) return;
          const dx=to.end[0]-from.end[0],dy=to.end[1]-from.end[1],length=Math.max(1,Math.hypot(dx,dy));
          const bow=2.2*Math.sin(clock/1900+link.phase);
          const control=bounded((from.end[0]+to.end[0])/2-dy/length*bow,(from.end[1]+to.end[1])/2+dx/length*bow);
          const d='M'+pair(from.end)+'Q'+pair(control)+' '+pair(to.end);
          link.path.setAttribute('d',d);
          link.signal.setAttribute('d',d);
          const crawl=(clock/1800+link.phase)%1;
          link.signal.style.strokeDashoffset=String(1-crawl*1.16);
          link.signal.style.opacity=String(smooth(crawl/.16)*(1-smooth((crawl-.8)/.2)));
        });
      }
      constellationFrame=requestAnimationFrame(paint);
    };
    constellationFrame=requestAnimationFrame(paint);
  }
  function startMotion() {
    const angle=reducedMotion.matches?0:currentSparkAngle();
    stopMotion();
    panel.dataset.motion='running';
    openingPoints=wavePoints(idleWaveTime);
    openingStarted=performance.now();
    panel.style.setProperty('--pc-web-emergence',0);
    if (!reducedMotion.matches) varyConstellation();
    if (!reducedMotion.matches) {
      spinOffset=angle;
      const frames=[{transform:'rotate('+angle+'deg)'},{transform:'rotate('+(angle+360)+'deg)'}];
      const timing={duration:2400,iterations:Infinity,easing:'linear'};
      spinAnimation=spark.animate(frames,timing);
      spinAnimation.playbackRate=0;
      spinAccelerationStarted=performance.now();
      if (constellation) animateConstellation();
    } else paintOpening(openingStarted+openingDuration);
  }
  function finishMotion() {
    const successful=panel.dataset.reviewOutcome!=='attention';
    if (!spinAnimation || reducedMotion.matches || panel.dataset.restoring==='true') { stopMotion(); panel.dataset.motion=successful?'settled':'rest'; progress.hidden=true; return; }
    const angle=(spinOffset+((Number(spinAnimation.currentTime)||0)%2400)/2400*360)%360;
    spinAccelerationStarted=null;
    openingStarted=null; openingPoints=null;
    spinAnimation.cancel();
    constellationFinished=performance.now();
    const target=angle+75;
    const duration=finishDuration;
    if (successful) {
      completionStarted=performance.now();
      completionAngle=(angle-90)*Math.PI/180;
      paintCompletion(0);
    }
    panel.style.setProperty('--pc-finish-duration',duration+'ms');
    panel.dataset.motion='finishing';
    const frames=[{transform:'rotate('+angle+'deg)'},{transform:'rotate('+target+'deg)'}];
    const timing={duration,easing:'cubic-bezier(.333333,.666667,.666667,1)',fill:'forwards'};
    spinAnimation=spark.animate(frames,timing);
    finishRevealTimer=setTimeout(()=>{panel.dataset.motion=successful?'confirming':'fading';},200);
    finishTimer=setTimeout(()=>{if(successful)paintCompletion(1);stopMotion();panel.dataset.motion=successful?'settled':'rest';progress.hidden=true;},duration);
  }
  reducedMotion.addEventListener('change',()=>{if(reducedMotion.matches){stopMotion();if(panel.dataset.state==='complete' && panel.dataset.reviewOutcome==='success')panel.dataset.motion='settled';if(!busy)progress.hidden=true;}});
  const waveObserver = new MutationObserver(startIdleWave);
  waveObserver.observe(panel,{attributes:true,attributeFilter:['data-motion']});
  document.addEventListener('visibilitychange',startIdleWave);
  reducedMotion.addEventListener('change',startIdleWave);
  startIdleWave();
  function reviewAnimation(startedAt, itemCount) {
    // Presentation timing only: final cart verification follows this animation.
    const duration = core.reviewDuration(itemCount);
    const remaining = Math.max(0,duration - (performance.now()-startedAt));
    const controller = new AbortController();
    controllers.add(controller);
    return new Promise((resolve,reject) => {
      const finish = error => {
        clearTimeout(timer); controllers.delete(controller);
        controller.signal.removeEventListener('abort',abort);
        if (error) reject(error); else resolve();
      };
      const abort = () => finish(Error('Review cancelled'));
      const timer = setTimeout(()=>finish(),remaining);
      controller.signal.addEventListener('abort',abort,{once:true});
    });
  }
  function clearItemResults() {
    products.querySelectorAll('[data-price-check-item]').forEach(el=>el.remove());
  }
  function setBusy(value, quiet = false) {
    busy = value;
    if (value && !quiet) clearItemResults();
    panel.setAttribute('aria-busy', String(value));
    all.disabled = value;
    all.textContent = value && !quiet ? copy.checking : hasReviewed || quiet ? copy.recheck : copy.all;
    apply.disabled = value;

  }
  function stage(completed, label, successful = true) {
    if (completed === 0) startMotion();
    progress.hidden = completed === 3;
    panel.dataset.state = completed === 3 ? 'complete' : 'working';
    mode.textContent = completed === 3 ? copy.complete : copy.working;
    bar.setAttribute('aria-valuenow', String(completed));
    bar.setAttribute('aria-valuetext', label);
    panel.querySelector('[data-price-check-fill]').style.width = (completed / 3 * 100) + '%';
    panel.querySelector('[data-price-check-stage]').textContent = label;
    panel.querySelector('[data-price-check-fraction]').textContent = completed + ' / 3';
    panel.querySelectorAll('[data-price-check-step]').forEach((el, index) => { el.dataset.complete = String(index < completed); });
    if (completed === 3) { panel.dataset.reviewOutcome=successful?'success':'attention'; finishMotion(); }
  }
  async function request(url, options = {}, timeout = 8000) {
    const controller = new AbortController();
    controllers.add(controller);
    let timedOut = false;
    const timer = setTimeout(() => { timedOut = true; controller.abort(); }, timeout);
    try {
      const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', redirect: 'error', ...options, signal: controller.signal});
      if (!response.ok) throw Object.assign(Error('Request failed'), {code:'http',status:response.status});
      try { return await response.json(); }
      catch(error) {
        if (controller.signal.aborted || error instanceof TypeError) throw error;
        throw Object.assign(Error('Invalid response'), {code:'invalid-json'});
      }
    } catch(error) {
      if (timedOut) throw Object.assign(Error('Request timed out'), {code:'timeout'});
      if (controller.signal.aborted) throw Object.assign(Error('Review cancelled'), {code:'cancelled'});
      if (error instanceof TypeError) throw Object.assign(Error('Connection interrupted'), {code:'network'});
      throw error;
    } finally { clearTimeout(timer); controllers.delete(controller); }
  }
  async function readJson(url) {
    const run = generation;
    for (let attempt = 0; attempt < 2; attempt++) {
      try { return await request(url + (url.includes('?') ? '&' : '?') + 'price_check=' + Date.now(), {}, attempt ? 12000 : 8000); }
      catch(error) {
        const transient = ['network','timeout'].includes(error.code) ||
          error.code === 'http' && (error.status === 408 || error.status === 429 || error.status >= 500);
        // Only reads retry. A cancelled/superseded review must never restart itself.
        if (attempt || run !== generation || !transient) throw error;
      }
    }
  }
  const readCart = () => readJson(config.cartUrl);
  function invalidate(message, preserveReceipt = true) {
    stopMotion();
    if (!preserveReceipt) forgetReceipt();
    const hadReview = busy || results.size > 0 || !!currentOffer;
    generation++;
    if (pendingRefresh) { const pending = pendingRefresh; pendingRefresh = null; pending.reject(Error('Cart changed')); }
    controllers.forEach(c => c.abort());
    clearTimeout(expiryTimer);
    results.clear();
    clearItemResults();
    verifiedCart = null;
    currentOffer = null;
    offerBox.hidden = true;
    progress.hidden = true;
    panel.dataset.state = 'idle';
    panel.dataset.restoring = 'false';
    mode.textContent = copy.idle;
    resultList.replaceChildren(); resultDetails.hidden = true; resultDetails.open = false;
    setBusy(false);
    announce(message && hadReview ? message : '', !!message && hadReview);
  }
  function render(key,result) {
    window.FsPriceCheckView.render({panel,products,copy,resultList,resultDetails},key,result);
  }
  function track(analytics,method,...args) {
    try { analytics?.[method]?.(...args); }
    catch (_) { /* Analytics must never affect pricing or cart cleanup. */ }
  }
  function refreshCart(cart) {
    return new Promise((resolve,reject) => {
      const timer = setTimeout(() => {
        if (pendingRefresh === pending) pendingRefresh = null;
        reject(Error('Cart refresh timed out'));
      },8000);
      const pending = {
        cart,
        resolve: () => { clearTimeout(timer); resolve(); },
        reject: error => { clearTimeout(timer); reject(error); }
      };
      pendingRefresh = pending;
      document.dispatchEvent(new CustomEvent('cart:build'));
    });
  }
  function matchingMarkup(cart) {
    try {
      const node=products.querySelector('[data-fs-price-snapshot]');
      if (!node) return null;
      const snapshot=JSON.parse(node.textContent);
      const signature=core.reviewSignature(cart);
      if (signature!==core.reviewSignature(snapshot.cart) || signature!==core.reviewSignature(snapshot.facts)) return null;
      if (cart.items.some(item=>{
        const fact=snapshot.facts.items.find(f=>f.key===item.key);
        return window.FsPriceCheckState.itemReviewSignature(item,fact,cart.currency)!==
          window.FsPriceCheckState.itemReviewSignature(snapshot.cart.items.find(i=>i.key===item.key),fact,cart.currency);
      })) return null;
      const rows=Array.from(products.querySelectorAll('.cart__item[data-key]'));
      if (rows.length!==cart.items.length || rows.some(row=>{
        const item=cart.items.find(item=>item.key===row.dataset.key);
        return !item || Number(row.querySelector('.js-qty__num')?.value)!==item.quantity;
      })) return null;
      return snapshot;
    } catch (_) { return null; }
  }
  // Native cart rendering already includes these exact facts. Avoid another fragile
  // HTML/JSON preview request when its prices, currency, keys and quantities agree.
  const readFacts = cart => {
    const snapshot=matchingMarkup(cart);
    return snapshot ? Promise.resolve(snapshot.facts) : readJson(config.reviewUrl);
  };
  function restoreFromMarkup(expectedCart = null, force = false) {
    if (endpoint) return false;
    const node=products.querySelector('[data-fs-price-snapshot]');
    if (!node || !force && node===restoredMarkup) return false;
    try {
      const {cart,facts}=JSON.parse(node.textContent);
      if (expectedCart && core.reviewSignature(expectedCart)!==core.reviewSignature(cart)) return false;
      if (expectedCart && expectedCart.items.some(item=>{
        const fact=facts.items.find(f=>f.key===item.key);
        return window.FsPriceCheckState.itemReviewSignature(item,fact,cart.currency)!==
          window.FsPriceCheckState.itemReviewSignature(cart.items.find(i=>i.key===item.key),fact,cart.currency);
      })) return false;
      if (cart.has_legacy_review_properties || core.reviewSignature(cart)!==core.reviewSignature(facts)) return false;
      const rows=Array.from(products.querySelectorAll('.cart__item[data-key]'));
      if(rows.length!==cart.items.length || rows.some(row=>{
        const item=cart.items.find(item=>item.key===row.dataset.key);
        return !item || Number(row.querySelector('.js-qty__num')?.value)!==item.quantity;
      })) return false;
      const receipt=loadReceipt(), policy=core.privatePolicy(config.privateOffer);
      const keys=core.reviewedKeys(receipt,cart,facts,receiptScope);
      panel.dataset.restoring='true';
      hasReviewed=hasReviewed || !!receipt || !!cart.attributes?.[config.privateOffer?.reviewAttribute];
      if(keys.length) showReview(cart,facts,cart.items.filter(item=>keys.includes(item.key)),policy,null,true);
      else { invalidate(); if(hasReviewed)announce(copy.changed,true); }
      restoredMarkup=node;
      setBusy(false); panel.dataset.restoring='false';
      return true;
    } catch (_) { panel.dataset.restoring='false'; return false; }
  }
  function showReview(after,facts,targets,policy,offerIssue,restoring) {
    clearItemResults(); results.clear(); resultList.replaceChildren(); resultDetails.hidden=true; resultDetails.open=false;
      const reviewed = window.FsPriceCheckView.reviewResults(core,config,after,facts,targets,policy,restrictedVendors);
      if(policy?.method==='tiered_codes' && reviewed.some(([,result])=>result.state==='private')) offerIssue=offerIssue||copy.offerFailed;
      verifiedCart = core.fingerprint(after);
      reviewed.forEach(([itemKey,result]) => {results.set(itemKey,result);render(itemKey,result);});
      const privateSavings = reviewed.reduce((sum,[,r])=>sum+(r.state==='privateApplied'?r.savings:0),0);
      const saleSavings = reviewed.reduce((sum,[,r])=>sum+(r.state==='sale'?r.savings:0),0);
      const hasPrivate = reviewed.some(([,r])=>r.state==='private');
      const messages = [];
      if (privateSavings) messages.push(format(copy.cartOffer,{percent:policy.percent,savings:money(privateSavings,after.currency)}));
      const previewSavings = reviewed.reduce((sum,[,r])=>sum+(r.state==='privatePreview'?r.savings:0),0);
      if (previewSavings) messages.push(format(copy.cartPreview,{percent:25,savings:money(previewSavings,after.currency)}));
      if (saleSavings) messages.push(format(privateSavings || previewSavings ?copy.cartSaleRetained:copy.cartSavings,{savings:money(saleSavings,after.currency)}));
      if (offerIssue) messages.push(offerIssue);
      else if (hasPrivate) messages.push(copy.cartPrivate);
      if (!messages.length) messages.push(copy.cartConfirmed);
      announce(offerIssue || copy.reviewComplete, true);
      const eligibleCount=after.items.filter(item=>core.priceReviewEligible(item)).length;
      if(restoring && (targets.length<eligibleCount || offerIssue)){stopMotion();progress.hidden=true;panel.dataset.state='idle';announce(copy.changed,true);}
      else stage(3,copy.complete,!offerIssue);
      hasReviewed=true;
      if (!restoring && !offerIssue) saveReceipt(after,facts);
      return {reviewed,offerIssue};
  }
  async function reviewCart(...args) {
    const run = () => reviewCartUnlocked(...args);
    return window.FsNativePromotionCoordinator ? window.FsNativePromotionCoordinator.withCartLock(run) : run();
  }
  async function reviewCartUnlocked(key, restoring = false, analytics = null) {
    const receipt = restoring ? loadReceipt() : null;
    if (restoring && (endpoint || busy)) return;
    panel.dataset.restoring=String(restoring);
    const run = ++generation, startedAt = performance.now();
    let attempted = false, refreshed = false, offerIssue = null, cart = null, phase = 'read-cart';
    delete panel.dataset.reviewError;
    setBusy(true,restoring);
    if (!restoring) { announce(''); stage(0,copy.stageReading); }
    currentOffer = null; offerBox.hidden = true;
    if (!restoring) { results.clear(); resultList.replaceChildren(); resultDetails.hidden = true; resultDetails.open = false; }
    try {
      cart = await readCart();
      track(analytics,'update',cart);
      if (run !== generation) return;
      if (!cart.items.some(core.priceReviewEligible)) { invalidate(); if(hasReviewed)announce(copy.changed,true); return; }
      // Legacy test carts may retain an empty line property. Fold only those
      // rows into an otherwise identical clean row, preserving total quantity.
      const merge=core.legacyMerge(cart);
      if(merge) {
        const current=await readCart();
        if(run!==generation)return;
        if(core.fingerprint(current)!==core.fingerprint(cart)){invalidate(copy.changed);return;}
        const contents=core.cartContents(cart,'_nw_reviewed_item');
        attempted=true;writingDiscount=true;
        try { cart=await request(config.updateUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:merge})}); }
        catch(_){cart=await readCart();}
        if(run!==generation)return;
        if(core.cartContents(cart,'_nw_reviewed_item')!==contents)throw Error('Cart quantity changed');
        await refreshCart(cart);refreshed=true;
        if(run!==generation)return;
        writingDiscount=false;
      }
      if (cart.attributes?.[config.privateOffer?.reviewAttribute]) hasReviewed=true;
      if(restoring && !receipt){invalidate();if(hasReviewed)announce(copy.changed,true);return;}
      phase = 'read-facts';
      let facts = await readFacts(cart);
      if (run !== generation) return;
      if (core.reviewSignature(facts) !== core.reviewSignature(cart)) { invalidate(copy.changed); return; }
      if (!cart.items.length) { invalidate(copy.changed); return; }
      const restoredKeys=restoring?core.reviewedKeys(receipt,cart,facts,receiptScope):null;
      if(restoring && !restoredKeys.length){invalidate();announce(copy.changed,true);return;}
      if (!restoring) stage(1,copy.stageReviewing);
      const policy = core.privatePolicy(config.privateOffer);
      const review = !restoring && config.privateOfferEnabled && policy ? core.variantReview(cart,facts,policy) : null;
      const hasLegacy = cart.items.some(item=>item.properties?._nw_reviewed_item);
      const plan=policy?.method==='tiered_codes'?core.codePlan(cart,facts,policy):null;
      const needsOffer=core.offerMissing(cart,facts,policy);
      const codesChanged=plan && JSON.stringify(plan.codes.map(c=>c.toLowerCase()).sort())!==JSON.stringify((cart.discount_codes||[]).map(d=>String(d.code).toLowerCase()).sort());
      const reviewChanged=review && cart.attributes?.[policy.reviewAttribute]!==review && (!plan || JSON.parse(review).items.length>0 || !!cart.attributes?.[policy.reviewAttribute]);
      if (!restoring && review && (hasLegacy || reviewChanged || needsOffer || codesChanged)) {
        if(plan?.conflict || core.hasOtherDiscount(cart,policy)) offerIssue=copy.offerConflict;
        else {
          const before=await readCart();
          if(run!==generation)return;
          if(core.fingerprint(before)!==core.fingerprint(cart)){invalidate(copy.changed);return;}
          const contents=core.cartContents(cart,'_nw_reviewed_item');
          stage(2,copy.stageApplying); writingDiscount=true; attempted=true;
          phase = 'apply-offer';
          try {
            cart=await request(config.updateUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:{[policy.reviewAttribute]:review},...(plan?{discount:plan.discount}:{})})});
          } catch(_){cart=await readCart();}
          if(run!==generation)return;
          if(cart.attributes?.[policy.reviewAttribute]!==review) offerIssue=copy.offerFailed;
          if(core.cartContents(cart,'_nw_reviewed_item')!==contents) offerIssue=copy.changed;
          // Remove only our obsolete private property. Shopify then merges identical
          // variants naturally; no quantities, personalizations or selling plans change.
          const cleanupLimit=cart.items.length;
          for(let count=0;!offerIssue && count<cleanupLimit;count++) {
            const legacy=cart.items.find(item=>item.properties?._nw_reviewed_item);
            if(!legacy)break;
            const current=await readCart();
            if(run!==generation)return;
            if(core.fingerprint(current)!==core.fingerprint(cart)){cart=current;offerIssue=copy.changed;break;}
            const properties={...legacy.properties,_nw_reviewed_item:''};
            try {
              cart=await request(config.changeUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:legacy.key,quantity:legacy.quantity,properties})});
            } catch(_){cart=await readCart();}
            if(run!==generation)return;
            if(core.cartContents(cart,'_nw_reviewed_item')!==contents){offerIssue=copy.changed;break;}
            if(cart.items.some(item=>item.properties?._nw_reviewed_item===legacy.properties._nw_reviewed_item)){offerIssue=copy.offerFailed;break;}
          }
          phase = 'refresh-cart';
          await refreshCart(cart);refreshed=true;
          if(run!==generation)return;
          phase = 'confirm-facts';
          facts=await readFacts(cart);
          if(run!==generation)return;
          if(core.reviewSignature(facts)!==core.reviewSignature(cart)){invalidate(copy.changed);return;}
          if(core.offerMissing(cart,facts,policy))offerIssue=offerIssue||copy.offerFailed;
        }
      }

      if (!restoring) await reviewAnimation(startedAt,cart.items.length);
      if (run !== generation) return;
      if (!restoring) stage(2,copy.stageConfirming);
      phase = 'confirm-cart';
      const after = await readCart();
      if (run !== generation) return;
      if (core.fingerprint(cart) !== core.fingerprint(after)) { invalidate(copy.changed); return; }
      cart = after;
      // Also repairs stale prices when returning to a tab after a code was applied elsewhere.
      const markup = products.querySelector('[data-fs-cart-state][data-cart-subtotal],.cart__items[data-cart-subtotal]');
      if (core.offerApplied(after,policy) && Number(markup?.dataset.cartSubtotal) !== after.total_price) {
        await refreshCart(after); refreshed = true;
        if (run !== generation) return;
      }
      const eligible = after.items.filter(item=>core.priceReviewEligible(item));
      const targets = restoring ? eligible.filter(item=>restoredKeys.includes(item.key)) : key ? eligible.filter(item=>item.key===key) : eligible;
      if (!targets.length) { invalidate(copy.changed); return; }
      phase = 'render-review';
      const summary=showReview(after,facts,targets,policy,offerIssue,restoring);
      track(analytics,'complete',after,summary.reviewed,summary.offerIssue);
      clearTimeout(expiryTimer);
    } catch (error) {
      track(analytics,'fail',error.code);
      if (run === generation) {
        // Diagnostic categories contain no cart, customer, or request payload data.
        panel.dataset.reviewError = phase + ':' + (error.code || 'review');
        // A failed background read does not revoke a saved review of the visible
        // cart. Any newer cart we did read must still match; new items stay unchecked.
        if (restoring && !attempted && restoreFromMarkup(cart,true)) return;
        const applied = cart && core.offerApplied(cart,core.privatePolicy(config.privateOffer));
        invalidate();
        announce(attempted && !refreshed ? copy.refreshFailed : applied ? copy.reviewDelayed : copy.unavailable,true);
      }
    } finally {
      track(analytics,'fail','cancelled');
      writingDiscount = false;
      if (run === generation) { setBusy(false); panel.dataset.restoring='false'; }
      // A late or uncertain write still requires a native cart redraw.
      if (attempted && !refreshed) document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }
  async function check(key) {
    if (busy || writingDiscount || window.FsCartReview?.isBusy()) return;
    let analytics = null;
    try {
      const snapshot=products.querySelector('[data-fs-price-snapshot]');
      analytics=window.FsPriceCheckAnalytics?.begin(snapshot ? JSON.parse(snapshot.textContent).cart : null);
    } catch (_) { /* Analytics must never prevent price verification. */ }
    if (!endpoint) return reviewCart(key,false,analytics);
    const run = ++generation, startedAt = performance.now();
    setBusy(true);
    currentOffer = null; offerBox.hidden = true;
    announce(copy.checking);
    stage(0,copy.stageReading);
    try {
      const before = await readCart();
      track(analytics,'update',before);
      if (run !== generation) return;
      const signature = core.fingerprint(before);
      if (verifiedCart !== signature) { results.clear(); resultList.replaceChildren(); resultDetails.hidden = true; resultDetails.open = false; }
      const eligible = before.items.filter(item=>core.priceReviewEligible(item));
      const targets = key ? eligible.filter(i => i.key === key) : eligible;
      if (!targets.length) throw Error('Cart changed');
      stage(1,copy.stageReviewing);
      const contents = core.cartContents(before, '_nw_reviewed_item');
      const data = await request(endpoint, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({version: 1, cartToken: before.token, currency: before.currency})
      });
      if (run !== generation) return;
      await reviewAnimation(startedAt,before.items.length);
      if (run !== generation) return;
      stage(2,copy.stageConfirming);
      const after = await readCart();
      if (run !== generation) return;
      if (contents !== core.cartContents(after, '_nw_reviewed_item')) { invalidate(copy.changed); return; }
      if (data.version !== 1 || !Array.isArray(data.items)) throw Error('Invalid comparison');
      if (after.total_price !== before.total_price || Number(products.querySelector('[data-fs-cart-state][data-cart-subtotal],.cart__items[data-cart-subtotal]')?.dataset.cartSubtotal) !== after.total_price) {
        await refreshCart(after);
        if (run !== generation) return;
      }
      verifiedCart = core.fingerprint(after);
      // The backend answers with display items per line; no offer is ever proposed here.
      const items = data.items;
      const rows = Array.from(products.querySelectorAll('.cart__item[data-key]'));
      const afterEligible = after.items.filter(item => core.priceReviewEligible(item));
      const afterTargets = key ? afterEligible.filter(i => i.key === key || String(i.variant_id) === String(key).split(':')[0]) : afterEligible;
      let renderedInRows = true;
      afterTargets.forEach(item => {
        const matching = items.find(entry => entry && (entry.key === item.key || String(entry.key) === String(item.variant_id)));
        // Verified lines carry no third-party offer list, so give the view an empty one.
        const base = matching ? {...matching} : {state: 'unavailable'};
        const result = {...base, key: item.key, title: item.product_title || item.title, offers: []};
        results.set(item.key, result); render(item.key, result);
        if (!rows.some(row => row.dataset.key === item.key || String(row.dataset.key).split(':')[0] === String(item.key).split(':')[0])) renderedInRows = false;
      });
      if (renderedInRows) { resultDetails.hidden = true; resultDetails.open = false; }
      currentOffer = null;
      offerBox.hidden = true;
      const flagged = items.some(entry => entry?.state === 'conflict' || entry?.state === 'unavailable')
        || afterTargets.some(item => results.get(item.key).state === 'unavailable');
      const label = typeof data.label === 'string' ? data.label.trim() : '';
      announce(flagged || !label ? copy.unavailable : (copy.reviewComplete || label), true);
      stage(3,copy.complete,!flagged);
      hasReviewed = true;
      panel.dataset.hasReviewed = 'true';
      setBusy(false);
      clearTimeout(expiryTimer);
      track(analytics,'complete',after,afterTargets.map(item=>[item.key,results.get(item.key)]));
    } catch (error) {
      track(analytics,'fail',error.code);
      if (run === generation) { invalidate(); announce(copy.unavailable, true); if (key) render(key, {state: 'unavailable'}); }
    } finally { track(analytics,'fail','cancelled'); if (run === generation) setBusy(false); }
  }
  async function applyOffer(...args) {
    const run = () => applyOfferUnlocked(...args);
    return window.FsNativePromotionCoordinator ? window.FsNativePromotionCoordinator.withCartLock(run) : run();
  }
  async function applyOfferUnlocked() {
    if (busy || !currentOffer || window.FsCartReview?.isBusy()) return;
    const offer = currentOffer, run = ++generation;
    setBusy(true); announce(copy.applying);
    let attempted = false;
    try {
      const before = await readCart();
      if (run !== generation) return;
      if (!core.offerForCart(offer, before)) { invalidate(copy.changed); return; }
      // Do not silently replace a shopper's existing code or claim a stack is supported.
      if (core.hasDiscount(before)) { announce(copy.offerConflict, true); return; }
      attempted = true;
      let after;
      try {
        after = await request(config.updateUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({discount: offer.code})});
      } catch (_) {
        // A timed-out write may have succeeded: reconcile once; never auto-repeat a discount write.
        after = await readCart();
      }
      if (run !== generation) return;
      invalidate();
      announce(core.applied(after, offer.code, before.total_price) ? copy.offerApplied : copy.offerFailed, !core.applied(after, offer.code, before.total_price));
    } catch (_) { if (run === generation) { invalidate(); announce(copy.offerFailed, true); } }
    finally {
      if (run === generation) setBusy(false);
      if (attempted) document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }
  // A checkout click must not race the native discount write.
  form.addEventListener('click', event => {
    if (writingDiscount && event.target.closest('[data-fs-checkout],.cart__checkout,#nvd-with-checkout-btn,#nvd-without-checkout-btn')) {
      event.preventDefault(); event.stopImmediatePropagation(); announce(copy.applying);
    }
  },true);
  form.addEventListener('submit', event => {
    if (writingDiscount) { event.preventDefault(); event.stopImmediatePropagation(); announce(copy.applying); }
  },true);
  all.hidden = false;
  all.textContent = hasReviewed ? copy.recheck : copy.all;
  all.addEventListener('click', () => check());
  apply.addEventListener('click', applyOffer);
  info.addEventListener('keydown', event => { if (event.key === 'Escape') { info.open = false; info.querySelector('summary').focus(); } });
  document.addEventListener('click', event => {
    if (!info.contains(event.target)) info.open=false;
    products.querySelectorAll('[data-price-check-item][open]').forEach(el=>{if(!el.contains(event.target))el.open=false;});
  });
  products.addEventListener('keydown',event=>{
    const disclosure=event.target.closest('[data-price-check-item]');
    if(event.key==='Escape' && disclosure){disclosure.open=false;disclosure.querySelector('summary').focus();}
  });
  // Existing cart code replaces the product subtree after quantity/discount changes.
  new MutationObserver(records => {
    const structural = records.some(r => Array.from(r.addedNodes).concat(Array.from(r.removedNodes)).some(n => n.nodeType === 1 && (n.matches('.cart__items,.cart__item,[data-fs-cart-state]') || n.querySelector('.cart__item'))));
    if (structural && pendingRefresh) {
      const pending = pendingRefresh;
      pendingRefresh = null;
      const markup = products.querySelector('.cart__items');
      const keys = Array.from(products.querySelectorAll('.cart__item[data-key]')).map(el=>el.dataset.key).sort();
      const expectedKeys = pending.cart.items.map(item=>item.key).sort();
      if (Number(markup?.dataset.cartSubtotal) === pending.cart.total_price && JSON.stringify(keys) === JSON.stringify(expectedKeys)) pending.resolve();
      else pending.reject(Error('Cart markup changed'));
      return;
    }
    if (structural) { invalidate(results.size ? copy.changed : null); restoreReview(true); }
  }).observe(products, {childList: true, subtree: true});
  form.addEventListener('change', event => { if (event.target.matches('.js-qty__num,#FsCartProtection,[data-fs-protection] input[type="checkbox"]')) invalidate(copy.changed); }, true);
  form.addEventListener('click', event => { if (event.target.closest('.js-qty__adjust,.cart__item-remove')) invalidate(copy.changed); }, true);
  document.addEventListener('cart:quantity.cart-page', () => invalidate(copy.changed));
  document.addEventListener('cart:quantity.cart-header', () => invalidate(copy.changed));
  document.addEventListener('fs:price-review-reset', () => {
    const reviewed = hasReviewed;
    restoredMarkup = null;
    invalidate(null,false);
    if (reviewed) announce(copy.changed,true);
  });
  document.addEventListener('fs:price-review-prune', event => {
    const ids = Array.isArray(event.detail?.variantIds) ? event.detail.variantIds.map(String) : [];
    memoryReceipt = window.FsCartReview?.pruneReceipt(loadReceipt(),ids) || null;
    receiptVariantIds = receiptVariantIds === null ? ids : receiptVariantIds.filter(id=>ids.includes(id));
    const reviewed = hasReviewed;
    restoredMarkup = null;
    invalidate(null,true);
    if (reviewed) announce(copy.changed,true);
  });
  const restoreReview = (fromMarkup=false) => {
    if (busy || writingDiscount || window.FsCartReview?.isBusy()) return;
    if (fromMarkup && restoreFromMarkup()) { panel.removeAttribute('data-restore-pending'); return; }
    if(document.hidden)return;
    reviewCart(null,true).finally(()=>panel.removeAttribute('data-restore-pending'));
  };
  window.addEventListener('pagehide', () => invalidate(null,true));
  window.addEventListener('pageshow', event => { if (event.persisted) restoreReview(); });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (busy) invalidate(null,true);
      else { stopMotion(); if(panel.dataset.state==='complete' && panel.dataset.reviewOutcome==='success')panel.dataset.motion='settled'; progress.hidden=true; }
    }
    else restoreReview();
  });
  window.addEventListener('storage', event => {
    if (event.key !== receiptKey) return;
    if (!event.newValue) invalidate(copy.changed,false); else { receiptVariantIds=null; restoreReview(); }
  });
  restoreReview(true);
  if(panel.dataset.queuedCheck==='true') {delete panel.dataset.queuedCheck;check();}
  });
})();


